"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var actionTypes_1 = __importDefault(require("../actionTypes"));
var SET_STATE = actionTypes_1.default.SET_STATE;
exports.default = (function (_a) {
    var context = _a.context;
    return {
        onStoreCreated: function (store) {
            var Provider = function (props) {
                var children = props.children, initialStates = props.initialStates;
                if (initialStates) {
                    Object.keys(initialStates).forEach(function (name) {
                        var initialState = initialStates[name];
                        if (initialState && store.dispatch[name][SET_STATE]) {
                            store.dispatch[name][SET_STATE](initialState);
                        }
                    });
                }
                return (react_1.default.createElement(react_redux_1.Provider, { store: store, context: context }, children));
            };
            return { Provider: Provider, context: context };
        },
    };
});
//# sourceMappingURL=provider.js.map